import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3b0e6bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loading-wrap"
}
const _hoisted_3 = {
  key: 1,
  class: "main-wrap"
}
const _hoisted_4 = { class: "list-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "main" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.02891 14.4979L5.25443 11.8148C5.05557 11.6735 4.78371 11.6963 4.61119 11.8688L3.83789 12.6421C3.64886 12.8311 3.64196 13.1354 3.82225 13.3328L8.24 18.17L8.42945 18.3761C8.81988 18.8009 9.48775 18.808 9.88721 18.3918L10.1 18.17L20.5707 7.26341C20.7592 7.06707 20.756 6.75604 20.5636 6.56358L19.8278 5.82781C19.6429 5.6429 19.3467 5.63171 19.1484 5.80214L9.02891 14.4979Z",
    fill: "#00C378"
  })
], -1))
const _hoisted_8 = {
  key: 1,
  class: "empty-text"
}

import { Loading, Field } from 'vant'
import { CancelServiceOrderParams } from '@/types/malfunction-repair'
import { ref, Ref, withDefaults } from 'vue'
import {
  showToastLoading,
  showToastSuccess,
  showConfirmModal,
  clearToast,
  showToastFail,
} from '@/utils/tools'
import { commonErrorHandle } from '@/utils/error-handle'
import { getRepairCancelOption, requestCancelOrder } from '@/apis/malfunction-repair'
import CommonPopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'detail-cancel',
  props: {
    guid: { default: '' },
    visible: { type: Boolean, default: false }
  },
  emits: ['update:visible', 'success'],
  setup(__props: any, { emit }) {

const props = __props as { guid: string, visible: boolean };




const loading = ref(false)
const parameter: Ref<CancelServiceOrderParams> = ref({
  cancel_reason: 0,
  cancel_remark: '',
})
const otherKey = '8'
const options: Ref<
  Array<{
    label: string
    value: string
  }>
> = ref([])

function listItemClickHandle(value: string) {
  parameter.value.cancel_reason = Number(value)
}
// 暂时取消原因弹窗
// function showCancelDialog() {
//   visible.value = true
// }

function handleShowChange(value: boolean) {
  emit('update:visible', value)
}

// 加载取消选项
async function initLoadingData() {
  loading.value = true
  try {
    const data = await getRepairCancelOption()
    // 硬编码 8 是 其他的选项，特别处理
    options.value = Object.keys(data)
      .filter((key) => key !== otherKey)
      .map((key) => ({
        label: data[key],
        value: key,
      }))
      .concat({
        label: '其他（请填写原因）',
        value: otherKey,
      })
    console.log('options.value', options.value)
  } catch (error) {
    console.log('erro', error)
  }
  loading.value = false
}
function verifyParams() {
  let message = ''
  const { cancel_reason, cancel_remark } = parameter.value
  if (String(cancel_reason) === otherKey && !cancel_remark) {
    message = '请填写原因'
  }
  if (message) {
    showToastFail(message)
    return false
  }
  return true
}
async function cancelHandle() {
  if (!verifyParams()) {
    return
  }
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认取消服务单？',
      confirmButtonText: '确认取消',
      cancelButtonText: '我再想想',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    let result = {
      ...parameter.value,
    }
    if (result.cancel_reason !== Number(otherKey)) {
      result.cancel_remark = ''
    }
    await requestCancelOrder(props.guid, result)
    clearToast()
    emit('update:visible', false)  
    showToastSuccess('取消成功')
    emit('success')
  } catch (error) {
    commonErrorHandle(error)
  }
}
initLoadingData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPopupWrap, {
    show: __props.visible,
    "onUpdate:show": [
      _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      handleShowChange
    ],
    title: "取消原因",
    teleport: "body"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading), { size: "48" })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (options.value.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("ul", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.value,
                          class: _normalizeClass(["van-hairline--bottom", Number(item.value) === parameter.value.cancel_reason ? 'activted' : '']),
                          onClick: ($event: any) => (listItemClickHandle(item.value))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", null, _toDisplayString(item.label), 1),
                            _hoisted_7
                          ]),
                          (item.value === otherKey)
                            ? _withDirectives((_openBlock(), _createBlock(_unref(Field), {
                                key: 0,
                                modelValue: parameter.value.cancel_remark,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((parameter.value.cancel_remark) = $event)),
                                type: "textarea",
                                rows: 4,
                                maxlength: "300",
                                "show-word-limit": "",
                                placeholder: "请填写其它原因",
                                class: "field-item"
                              }, null, 8, ["modelValue"])), [
                                [_vShow, Number(item.value) === parameter.value.cancel_reason]
                              ])
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_5))
                      }), 128))
                    ]),
                    _createVNode(CommonFooterNextButton, {
                      class: "footer-button-wrap",
                      disabled: !parameter.value.cancel_reason,
                      title: "确定",
                      onClick: cancelHandle
                    }, null, 8, ["disabled"])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无数据"))
            ]))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})